
import { defineComponent, reactive } from 'vue'
import { store } from '@/store'

export default defineComponent({
  name: 'AppHero',
  components: { },
  setup() {
    const state = reactive({
      frame: 0,
      frames: 3
    })

    function createRoute() {
      store.user.createRoute()
    }

    window.setInterval(() => {
      state.frame = state.frame < state.frames - 1 ? state.frame + 1 : 0
    }, 5000)

    return { state, createRoute }
  }
})
